module.exports = __webpack_public_path__ + "image/solution_banner_insurance.jpg";